import {SxProps, Theme, useTheme} from "@mui/material";

const useButtonStyles = () => {
    const theme = useTheme();
    const ButtonStyles : {[property:string] : SxProps<Theme>}  = {
         containedSecondary:{
             textTransform : "capitalize",
             fontFamily: theme?.font?.fontFamily.primary,
             fontSize:'0.7rem',
             fontWeight:'600',
             minWidth:'8rem',
             py:1.2,
             backgroundColor: theme?.color?.secondary,
             color: theme.color?.background,
             '&:hover': {
                 backgroundColor:theme?.color?.primary
            }
        },
        containedPrimary:{
            textTransform : "capitalize",
            fontFamily: theme?.font?.fontFamily.primary,
            backgroundColor: theme?.color?.primary,
            color: theme.color?.background,
            fontSize:'0.7rem',
            py:1.2,
            minWidth:'8rem',
            fontWeight:'600',
            '&:hover': {
                backgroundColor:theme?.color?.secondary
            }
        },
        containedDanger:{
            textTransform : "capitalize",
            fontFamily: theme?.font?.fontFamily.primary,
            backgroundColor: theme?.color?.error,
            color: theme.color?.background,
            fontSize:'0.7rem',
            py:1.2,
            minWidth:'8rem',
            fontWeight:'600',
            '&:hover': {
                backgroundColor:theme?.color?.error
            }
        },
        outlinedPrimary:{
            textTransform : "capitalize",
            fontFamily: theme?.font?.fontFamily.primary,
            border:`${theme.border?.xsmall}${theme.color?.primary}`,
            fontSize:'0.7rem',
            py:1.2,
            minWidth:'8rem',
            fontWeight:'600',
            color: theme?.color?.primary,
            '&:hover': {
                border:`${theme.border?.xsmall}${theme.color?.primary}`,
                color: theme?.color?.primary,
                backgroundColor: theme.color?.primaryLight
            }
        },
        outlinedSecondary:{
            textTransform : "capitalize",
            fontFamily: theme?.font?.fontFamily.primary,
            border:`${theme.border?.xsmall}${theme.color?.secondary}`,
            fontSize:'0.7rem',
            py:1.2,
            minWidth:'8rem',
            fontWeight:'600',
            color: theme?.color?.secondary,
            '&:hover': {
                border:`${theme.border?.xsmall}${theme.color?.secondary}`,
                color: theme?.color?.secondary,
                backgroundColor: theme.color?.secondaryLight
            }
        },
        outlinedDanger:{
            textTransform : "capitalize",
            fontFamily: theme?.font?.fontFamily.primary,
            border:`${theme.border?.xsmall}${theme.color?.error}`,
            fontSize:'0.7rem',
            py:1.2,
            minWidth:'8rem',
            fontWeight:'700',
            color: theme?.color?.error,
            '&:hover': {
                border:`${theme.border?.xsmall}${theme.color?.error}`,
                color: theme?.color?.error,
                backgroundColor: theme.color?.secondaryLight
            }
        },
        textSecondary:{
            textTransform : "capitalize",
            fontFamily: theme?.font?.fontFamily.primary,
            fontSize:'0.875rem',
            py:1.2,
            minWidth:'8rem',
            fontWeight:'600',
            color: theme?.color?.secondary,
            '&:hover': {
                color: theme?.color?.primary,
                backgroundColor: ""
            }
        },
        textDanger:{
            textTransform : "capitalize",
            fontFamily: theme?.font?.fontFamily.primary,
            fontSize:'0.875rem',
            py:1.2,
            minWidth:'8rem',
            fontWeight:'600',
            color: theme?.color?.error,
        },
        buttonText: {
            textTransform : "capitalize",
            fontFamily: theme?.font?.fontFamily.primary,
            fontWeight: "600",
            borderRadius: "8px",
            fontSize: "0.7rem",
        }
    };
    return ButtonStyles;
}

export default useButtonStyles